import { render, staticRenderFns } from "./zAutorizacaoAdmin.vue?vue&type=template&id=0efdd1b8&scoped=true&"
import script from "./zAutorizacaoAdmin.vue?vue&type=script&lang=js&"
export * from "./zAutorizacaoAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0efdd1b8",
  null
  
)

export default component.exports